import { Link } from "react-router-dom";
import PremiumLayout from "./PremiumLayout";

const PILLARS = [
  {
    n: "01",
    title: "Civil & Structural Construction",
    subtitle: "Engineering precision. Materials that outlive fashion.",
    img: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1600&auto=format&fit=crop&q=80",
    points: [
      "In-house RCC & structural design",
      "Cast-in-situ + prefab hybrid execution",
      "Third-party QA/QC on every pour",
      "Site engineering & schedule ownership",
    ],
  },
  {
    n: "02",
    title: "Interior Architecture",
    subtitle: "Spatial choreography, custom lighting, bespoke joinery.",
    img: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1600&auto=format&fit=crop&q=80",
    points: [
      "Modular kitchen & wardrobe design",
      "False ceiling & lighting composition",
      "Custom joinery & millwork",
      "Curated material & finish palettes",
    ],
  },
  {
    n: "03",
    title: "Turnkey Projects",
    subtitle: "One studio. One contract. Concept to hand-off.",
    img: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&auto=format&fit=crop&q=80",
    points: [
      "Architecture + structure + interiors",
      "Landscape & exterior lighting",
      "Fixed timeline & fixed scope pricing",
      "Single point of accountability",
    ],
  },
];

export default function PremiumExpertise() {
  return (
    <PremiumLayout>
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 pb-8">
        <div className="mono gold">Expertise</div>
        <h1 className="serif text-5xl md:text-7xl leading-[1.02] mt-4 cream">
          Three studios. <span className="gold italic">One philosophy.</span>
        </h1>
        <p className="mt-6 max-w-2xl text-[#B8B0A0] text-lg leading-relaxed">
          Every project — whether it&apos;s ground-up construction, a soft-touch renovation,
          or a full turnkey build — is drawn, engineered and installed by the same studio.
        </p>
      </section>

      {PILLARS.map((p, i) => {
        const flip = i % 2 === 1;
        return (
          <section key={p.n} data-testid={`pillar-${p.n}`}
                   className="border-t border-[#1F1F1F] py-20 md:py-28">
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-10 md:gap-16 items-center">
              <div className={`${flip ? "md:order-2" : ""}`}>
                <div className="mono gold">{p.n}</div>
                <h2 className="serif text-4xl md:text-6xl leading-[1.05] cream mt-4">{p.title}</h2>
                <p className="text-lg text-[#DDD5C4] mt-6">{p.subtitle}</p>
                <ul className="mt-8 space-y-3">
                  {p.points.map((it) => (
                    <li key={it} className="flex items-start gap-3 text-[#B8B0A0]">
                      <span className="gold serif text-xl leading-none mt-1">•</span>
                      <span>{it}</span>
                    </li>
                  ))}
                </ul>
                <Link to="/contact" className="inline-block mt-10 mono gold border-b border-[#C9A96E]/40 hover:border-[#C9A96E]">
                  Discuss a {p.title.split("&")[0].trim()} project →
                </Link>
              </div>
              <div className={`${flip ? "md:order-1" : ""} relative overflow-hidden border border-[#1F1F1F] aspect-[4/5]`}>
                <img src={p.img} alt={p.title}
                     className="absolute inset-0 w-full h-full object-cover ken-burns" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/40 to-transparent" />
              </div>
            </div>
          </section>
        );
      })}
    </PremiumLayout>
  );
}
